import { render, staticRenderFns } from "./FeaturedOfferComponent.vue?vue&type=template&id=26aa3faf&scoped=true"
import script from "./FeaturedOfferComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedOfferComponent.vue?vue&type=script&lang=js"
import style0 from "./FeaturedOfferComponent.vue?vue&type=style&index=0&id=26aa3faf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aa3faf",
  null
  
)

export default component.exports